import { StationType } from "@/enums/stationType"

export class TopStation {
    id: number
    label: string
    type: StationType
    constructor(
        id: number,
        label: string,
        type: StationType,
    ) {
        this.id = id
        this.label = label
        this.type = type
    }
}

export const validateTopStation = (obj: any): void => {
    if (!obj.id) throw new Error("obj.id is mandatory")
    if (!obj.label) throw new Error("obj.label is mandatory")
    if (!obj.type) throw new Error("obj.type is mandatory")
}

export const buildTopStation = (obj: any): TopStation => {
    validateTopStation(obj)
    const topStation = new TopStation(
        obj.id, obj.label, obj.type
    )
    return topStation
}